<div class="search">
    <i class="magnifier fa fa-search" ng-if="showMenu"></i>
    <input ng-keydown="keyHandler($event)" name="{{searchableSelect.name}}" ng-model="searchableSelect.searchValue" ng-value="searchableSelect.searchString" ng-focus="toggleMenu(true)"
           ng-class="{ closed: !showMenu }" c-searchable-select-required="searchableSelect.validation.required"/> 
    <i ng-click="toggleMenu()" class="menu-angle fa fa-angle-down"></i>
</div>
<div ng-if="showMenu" class="select-menu-container">
    <!-- select items (may be filtered) -->
    <ul ng-if="searchableSelect.items.length>0" class="items">
        <li ng-repeat="item in searchableSelect.items | filter:searchableSelect.searchValue track by $index" ng-click="selectItem(item, $index)">
            <div ng-if="item.indicatorColor" ng-class="item.indicatorColor" style="padding: 0 3px 0 0; margin: 1px 0 1px 0;"></div>
            <div class="badge-and-text">
                <div ng-class="{selected: ($index === searchableSelect.selectedItemIndex)}" ng-bind-html="item.text|cHighlight:[searchableSelect.searchString]"></div>
                <div ng-if="item.additionalInfo && item.additionalInfo.length > 0" class="additional-info">{{item.additionalInfo}}</div>
            </div>
        </li>
        <centuri-scroll-monitor enter-viewport="searchableSelect.loadNextPage()" offset="100" done-loading="searchableSelect.doneLoading()"></centuri-scroll-monitor>
    </ul>
    <!-- additional links/tools -->
    <ul ng-if="searchableSelect.tools.length>0" class="tools">
        <li ng-repeat="tool in searchableSelect.tools track by $index">
            <span ng-click="toolClick(tool)">{{ ::tool.text }}</span>
        </li>
    </ul>
</div>